// tslint:disable-next-line:typedef
export const SSO = {
    LOGIN_FLOW: {
        KEY: 'LoginFlow',
        SSO: 'SSO',
        LEGACY: 'Legacy',
        UNKNOWN: 'Unknown',
    },
};
